/**
 * Object representing conversion rates for different units of measurement.
 * The base unit for each category is the first unit listed and is metric.
 *
 * @type {Object}
 * @property {Object} volume - Conversion rates for volume units.
 * @property {number} volume.L - Conversion rate for liters.
 * @property {number} volume.USG - Conversion rate for US gallons.
 * @property {number} volume.IG - Conversion rate for Imperial gallons.
 * @property {number} volume.m3 - Conversion rate for cubic meters.
 * @property {number} volume.ft3 - Conversion rate for cubic feet.
 */
const conversionRates = {
    volume: {
        L: 1,
        ml: 0.001,
        USG: 3.78541,
        IG: 4.54609,
        m3: 1000,
        ft3: 28.3168,
    },
};

/**
 * Factor used for sample value calculations
 * @type {number}
 */
const FACTOR = 0.1;

/**
 * Converts a value from one unit to another unit within a specific category.
 *
 * @param {string} category - The category of conversion rates. ex: volume, length, etc.
 * @param {string} fromUnit - The unit to convert from.
 * @param {string} toUnit - The unit to convert to.
 * @param {number} value - The value to convert in fromUnits.
 * @throws {Error} If either the fromUnit or toUnit is unsupported in the given category.
 * @return {number} The converted value in toUnits.
 */
const convertUnits = (category, fromUnit, toUnit, value) => {
    const fromRate = conversionRates[category][fromUnit];
    const toRate = conversionRates[category][toUnit];
    if (fromUnit === toUnit) {
        throw new Error('Cannot convert to the same unit');
    }
    if (fromRate === undefined || toRate === undefined) {
        throw new Error(`Unsupported unit conversion from ${fromUnit} to ${toUnit}`);
    }

    const valueInBaseUnit = value * fromRate;
    return valueInBaseUnit / toRate;
};

module.exports = {conversionRates, convertUnits, FACTOR};
